module.exports = __webpack_public_path__ + "media/images/external_link_white-6921ae61aa0120f6be60e89cf0544193.png";